import { LogCannon } from '@ace-clublabs/log-cannon';
import axios from 'axios';
import StatusCode from 'status-code-enum';
import { ErrorType } from '../../shared/types';
import CookieHelper from '../../utils/cookieHelper';
import { SendConfirmationEmail, ISendConfirmationEmailRequest, ISendConfirmationEmailResponse } from '../contracts';
import { createAxiosConfig } from '../mockHelper';

export const SendConfirmationEmailApi =
  (endpoint: string): SendConfirmationEmail =>
  async (request: ISendConfirmationEmailRequest) => {
    try {
      const { emails, transactionId, firstName } = request;

      LogCannon.blast('SendConfirmationEmailApi start', {
        endpoint,
        transactionId,
      });
      const scenario = CookieHelper.getCookie('scenario');
      const config = createAxiosConfig(scenario, endpoint);
      const response = await axios.post(endpoint, { emails, transactionId, firstName }, config);
      if (response.status !== StatusCode.SuccessOK) {
        LogCannon.blast('SendConfirmationEmailApi failed');
        throw new Error('Failed to send confirmation email');
      } else {
        LogCannon.blast('SendConfirmationEmailApi success');
        return Promise.resolve({ status: 'success' } as ISendConfirmationEmailResponse);
      }
    } catch (error: any) {
      LogCannon.error('SendConfirmationEmail error', { error });
      return Promise.reject({
        message: error.response?.data?.message || 'Failed to send confirmation email',
        requestId: error.response?.data?.requestId,
        type: ErrorType.SYSTEM_ERROR,
      });
    }
  };
